import { axiosApigateway } from "../../../api";
import { dac_actionType } from "../../actionTypes/adminAction-actionTypes/dac-actionType";

const createDacData = (responeData) => {
    const dacData = responeData.map((o) => {
        return {
        id : o?.id_pk,
        name : o?.name,
        description : o?.description,
        // isDynamicCountry : o?.addCountries,
        // isDynamicProduct : o?.addProducts,
        vvmcApplicationRoleApplicationRoleId : o?.vvmcApplicationRoleApplicationRoleId,
        vvmcDocumentTypeGroupDocTypeGroupId : o?.vvmcDocumentTypeGroupDocTypeGroupId
    };
  });
  return dacData;
};

export function getDacAllRequest(){
   
    return async(dispatch)=> {
        try{
            // calling API
            const response = await axiosApigateway.get("/dac-roles");
            const data = createDacData(response?.data?.data || []);
            if(response){
                dispatch({
                    type : dac_actionType.GET_DAC_SUCCESS,
                    data : data //response.data.data
                });
            }
        }catch(error){
            dispatch({
                type : dac_actionType.GET_DAC_FAILURE,
                data : error
            });
        }
    };
}

export function initiliseDacReduerState(){
    return(dispatch) => {
        dispatch({
            type: dac_actionType.EDIT_REQUEST_START
        });
    };
}

const  getErrorMessage =(error, isEditRequest) => {
    let errorMessage;
  if (error?.response?.data && isEditRequest) {
    errorMessage = [
      error?.response?.data?.errormessage || "Error while updating group!"
    ];
  } else if (!isEditRequest && error?.response?.data) {
    errorMessage = [
      error?.response?.data?.errormessage || "Error while creating group!"
    ];
  } else {
    errorMessage = ["Something went Wrong, Please try after some time!"];
  }
  return errorMessage;
};

export function searchForRoleID(vvmcApplicationRoleApplicationRoleId){
    return async(dispatch)=> { 
        dispatch({type: dac_actionType.SEARCH_VVMC_ROLE_LOADER_ON});
        try{
            const response = await axiosApigateway.get(`/vvmc-application-roles`, {params :{ vvmcApplicationRoleApplicationRoleId:vvmcApplicationRoleApplicationRoleId }});            
            dispatch({
                type: dac_actionType.SEARCH_ROLE_ID_SUCCESS,
                data: response,
                message: ""
            });
            dispatch({type: dac_actionType.SEARCH_VVMC_ROLE_LOADER_OFF});
            return {response, success: true};            
        }catch(error){
            dispatch({
                type: dac_actionType.SEARCH_ROLE_ID_FAILURE,
                data: error,
                message: error?.response?.data?.error
            });

            dispatch({type: dac_actionType.SEARCH_VVMC_ROLE_LOADER_OFF});
            return {success: false};            
        }
    };
}

export function searchForDocID(docType){
    return async(dispatch)=> { 
        dispatch({type: dac_actionType.SEARCH_DOCUMENT_LOADER_ON});

        try{
            const response = await axiosApigateway.get(`/vvmc-document-type-groups`, {params :{ docType:docType }});                      
            dispatch({
                type: dac_actionType.SEARCH_DOC_ID_SUCCESS,
                data: response,
                documentTypeSuccessMessage: ""
            });
            dispatch({type: dac_actionType.SEARCH_DOCUMENT_LOADER_OFF});
            return {response, success: true};
        }catch(error){            
            const errorMessage = error?.response?.data?.error;
            dispatch({
                type: dac_actionType.SEARCH_DOC_ID_FAILURE,
                data: error,
                documentTypeSuccessMessage: errorMessage
            });
            dispatch({type: dac_actionType.SEARCH_DOCUMENT_LOADER_OFF});
            return {success: false};
        }
    };
}

export function resetReducerCorrespondingToRoleID() {
    return async(dispatch)=> {
        dispatch({
            type: dac_actionType.RESET_SEARCH_ROLE
        });
    };
}
export function saveDacRequest(data, isEditRequest, dacId){
    return async(dispatch) => {
        dispatch(initiliseDacReduerState());
        try{
            let response;
            if(isEditRequest){
                response = await axiosApigateway.put(`/dac-roles/${dacId}`, data);
            }else{
                response = await axiosApigateway.post("/dac-roles", data);
            }
            if(response){
                dispatch({
                    type : dac_actionType.EDIT_REQUEST_SUCCESS,
                    data : response?.data?.message || isEditRequest ? "DAC Role successfully updated." : "DAC Role successfully added."
                });
            }
            dispatch(getDacAllRequest());
        }catch(error){
            const errorMsg = getErrorMessage(error, isEditRequest);
            dispatch({
                type: dac_actionType.EDIT_REQUEST_FAILURE,
                data : errorMsg
            });
        }
    };
}

export function deleteDacRequest(dacId){
    return async(dispatch) => {
        dispatch(initiliseDacReduerState());
        try{
            const response  = await axiosApigateway.delete(`/dac-roles/${dacId}`);
            console.log("respone", response);
            if(response){
                dispatch({
                    type : dac_actionType.EDIT_REQUEST_SUCCESS,
                    data : response?.data?.message
                });
                dispatch(getDacAllRequest());
            }
            
        }catch(error){
            dispatch({
                type: dac_actionType.EDIT_REQUEST_FAILURE
            });
        }
    };
}

export function getAllVvmcApplicationRole(){
   
    return async(dispatch)=> {
        try{
            // calling API
            const response = await axiosApigateway.get("/get-all-vvmc-application-roles");
            // const data = createDacData(response?.data?.data || []);
            if(response){
                dispatch({
                    type : dac_actionType.GET_ALL_VVMC_ROLES_SUCCESS,
                    data : response.data.data
                });
            }
        }catch(error){
            dispatch({
                type : dac_actionType.GET_ALL_VVMC_ROLES_FAILURE,
                data : error
            });
        }
    };
}

export function   getAllVvmcDocumentTypes(){
   
    return async(dispatch)=> {
        try{
            // calling API
            const response = await axiosApigateway.get("/get-all-vvmc-document-types");
            // const data = createDacData(response?.data?.data || []);
            if(response){
                dispatch({
                    type : dac_actionType.GET_ALL_VVMC_DOC_TYPE_GROUPS_SUCCESS,
                    data : response.data.data
                });
            }
        }catch(error){
            dispatch({
                type : dac_actionType.GET_ALL_VVMC_DOC_TYPE_GROUPS_FAILURE,
                data : error
            });
        }
    };
}
